import axios from "axios";

const create = () => axios.post("/neeto_sso/api/v1/subscription_request");

const subscriptionRequestApi = { create };

export default subscriptionRequestApi;
